import React, { useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { Card } from "react-bootstrap";
import {
  FormDateField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchCurrency from "../../../setup/finance/searchCurrency";
import { DialogActions } from "@material-ui/core";
import { useFormikContext } from "formik";
import { Editor } from "primereact/editor";
function JournalEntriesHead(props) {
  const [openSearchCurrency, setOpenSearchCurrency] = useState(false);
  const { values, setFieldValue } = useFormikContext();
  return (
    <React.Fragment>
      <div className="tabview mb-3">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="Journal Entry Main" rightIcon="fas fa-th-large">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Journal Entry Header</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormDateField
                            label="Document Date"
                            name="documentDate"
                          />
                          <FormTextField
                            label="Currency"
                            name="currencyCode"
                            searchButton
                            onSearchClick={() => {
                              setOpenSearchCurrency(true);
                            }}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormTextField
                            label="Amount"
                            name="totalAmount"
                            currencyField
                            currencyCode={values.currencyCode}
                            readonly
                          />
                          <FormTextField
                            label="Exchange Rate To Base Currency"
                            name="exchangeRate"
                            readonly
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel header={"Note"} rightIcon="fas fa-sticky-note">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        onTextChange={(e) => {
                          setFieldValue("note", e.htmlValue);
                        }}
                        value={values.note}
                        placeholder="Type your notes here..."
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
      <DialogLayout
        open={openSearchCurrency}
        title="Search Currency"
        onCloseDialog={() => {
          setOpenSearchCurrency(false);
        }}
        maxWIdth="sm"
      >
        <SearchCurrency
          onSelectCurrency={(currency) => {
            setFieldValue("currencyID", currency.ID);
            setFieldValue("currencyCode", currency.currencyCode);
            setFieldValue("exchangeRate", currency.exRateToBaseCurr);
            setOpenSearchCurrency(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCurrency(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default JournalEntriesHead;
